var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Loader'):_c(_vm.currentTabComponent,{tag:"component",attrs:{"projectDetail":_vm.project},on:{"editProject":_vm.editProject,"deleteProject":_vm.delProject,"closeEdit":_vm.closeEdit}})}
var staticRenderFns = []

export { render, staticRenderFns }